import React from "react";
import { cn } from "@/lib/utils";
import { useTheme } from "@/contexts/ThemeProvider";

function cardStyles(theme) {
  switch (theme) {
    case "theme-castlewood":
      return "rounded-[2px] border border-border bg-card text-card-foreground";
    case "theme-vela":
      return "rounded-[10px] border border-border bg-card text-card-foreground";
    case "theme-brionj":
      return "rounded-none border border-border bg-card text-card-foreground";
    case "theme-admin":
      return "rounded-[8px] border border-border bg-card text-card-foreground shadow-[var(--shadow-elev-1)]";
    default:
      return "rounded-[8px] border border-border bg-card text-card-foreground";
  }
}

const BrandCard = React.forwardRef(({ className, children, ...rest }, ref) => {
  const { theme } = useTheme();
  return (
    <div ref={ref} className={cn(cardStyles(theme), className)} {...rest}>
      {children}
    </div>
  );
});
BrandCard.displayName = "BrandCard";

export default BrandCard;
export { BrandCard };
